/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledPaginatorWrapper,
  StyledpaginatorText,
  StyledArrow,
  StyledIcon,
  StyledIconBot
} from './style';

import { ArrowLeft } from '../../../../assets/images/index';

const PaginatorVertical = ({
  visibleItems,
  totalItems,
  className,
  loadMore
}) => {
  const pageEnd = totalItems === visibleItems;
  return visibleItems && totalItems ? (
    <StyledPaginatorWrapper className={className}>
      <StyledpaginatorText>{`${visibleItems} de ${totalItems}`}</StyledpaginatorText>
      {!pageEnd && (
        <div onClick={loadMore}>
          <StyledArrow>
            <StyledIcon svg={ArrowLeft} />
            <StyledIconBot svg={ArrowLeft} />
          </StyledArrow>
        </div>
      )}
    </StyledPaginatorWrapper>
  ) : (
    <React.Fragment />
  );
};
PaginatorVertical.propTypes = {
  visibleItems: PropTypes.number,
  totalItems: PropTypes.number
};

export default PaginatorVertical;
